window.analyticsVar = {
  context: {
    app: "account",
    app_version: import.meta.env.VITE_APP_VERSION,
  },
};
